<template>
  <div class="player-controls">
    {{ currentlyPlaying.currentSong }}
    <audio ref="audioRef" controls />
  </div>
</template>

<script lang="ts">
import { watch, ref, Ref } from 'vue';
import { currentlyPlayingStore, fileSystemStore, musicStore } from '../store';
import { CurrentlyPlayingState } from '../store/CurrentlyPlayingStore';
import { generatePng } from '../util/metadataUtilities';

export default {
  setup() {
    const currentlyPlaying = currentlyPlayingStore.getState();
    const audioRef: Ref<HTMLAudioElement> = ref(null);

    setInterval(() => {
      if (audioRef.value) {
        const el = audioRef.value;

        if (el.duration) {
          console.log('post');
          navigator.mediaSession.setPositionState({
            duration: el.duration,
            playbackRate: 1,
            position: el.currentTime
          });
        }
      }
    }, 500);

    return {
      audioRef,
      currentlyPlaying,
      ...useCurrentlyPlaying(currentlyPlaying, audioRef),
      ...usePlaybackControls(currentlyPlaying, audioRef)
    };
  }

};

function useCurrentlyPlaying(state: CurrentlyPlayingState, el: Ref<HTMLAudioElement>) {
  watch(() => state.currentSong, async (newSong) => {
    const file = await fileSystemStore.resolveFile(newSong.path);
    const audio = el.value;
    audio.src = URL.createObjectURL(file);
    audio.play();

    audio.onended = () => currentlyPlayingStore.next();

    // Push info to Media Session
    if (navigator.mediaSession && typeof MediaMetadata !== 'undefined') {
      const album = musicStore.getState().albums[newSong.album];

      const art = await generatePng(album);

      // eslint-disable-next-line no-undef
      const meta = new MediaMetadata({
        title: newSong.title,
        artist: newSong.artist,
        album: newSong.album,
        artwork: [
          { src: URL.createObjectURL(art.blob), sizes: `${art.width}x${art.height}`, type: 'image/png' }
        ]
      });
      navigator.mediaSession.metadata = meta;
      console.log('set media', meta);
    }
  });

  return {

  };
}

function usePlaybackControls(state: CurrentlyPlayingState, el: Ref<HTMLAudioElement>) {
  const handlers: { [key in MediaSessionAction]?: (details?: any) => void} = {
    play() {
      el.value.play();
    },
    pause() {
      el.value.pause();
    },
    previoustrack() {
      currentlyPlayingStore.previous();
    },
    nexttrack() {
      currentlyPlayingStore.next();
    },
    seekbackward() {
      el.value.currentTime -= 5;
    },
    seekforward() {
      el.value.currentTime += 5;
    },
    seekto(details) {
      debugger;
    }
  };

  let name: MediaSessionAction;
  for (name in handlers) {
    navigator.mediaSession.setActionHandler(name, handlers[name]);
  }

  return {};
}

</script>

<style lang="scss" scoped>
.player-controls {
  &.fixed {
    position: fixed;
    z-index: 999;
    top: 0;
    left: 0;
    right: 0;
    height: 4rem;
  }
  border-bottom: 1px solid #666;
  background-color: #48f;
}
</style>
